import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultWebinarsPage from './Pages/DefaultWebinarsPage';
import WizardPage from './Pages/WizardPage';

const WebinarsRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:webinarId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultWebinarsPage />
            </Route>
        </Switch>
    );
};

export default WebinarsRouter;
